import gql from 'graphql-tag';

export default gql`
  fragment contentWebsiteFragment on ContentWebsite {
    id
    uuid
    url
    createdAt
    updatedAt
  }
`;
